import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/mediabook/mediabook/src/templates/Standalone.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Information Technology`}</h1>
    <p>{`Information Technology is a key component to students’ success at Make School. You will need to set
up the following accounts:`}</p>
    <h2>{`GSuite Account`}</h2>
    <p>{`All Make School students will receive an official Make School email address, which should be used
for all communication while you’re a student. This email address will be your legal first name, a
period, and your legal last name, followed by @students.makeschool.org (e.g.,
`}<a parentName="p" {...{
        "href": "mailto:john.doe@students.makeschool.org"
      }}>{`john.doe@students.makeschool.org`}</a>{`). This account is part of the Google Suite, which also gives access
to all administrative Google interfaces (i.e., Google Drive, Google Docs, etc.).`}</p>
    <h2>{`Gradescope Account`}</h2>
    <p><a parentName="p" {...{
        "href": "https://www.gradescope.com/"
      }}>{`Gradescope`}</a>{` is an assignment submission, grading, and analytics
platform that allows us to provide fast and accurate feedback on your work. All assigned work will
be submitted through Gradescope, and assignment and exam grades will be returned through Gradescope.
As soon as grades are posted, you will receive an email notification so that you can log in and see
your feedback. You may also submit regrade requests if you feel we have made a mistake.`}<strong parentName="p">{` Note:
Final grades are posted on your Dashboard on the Make School Student Portal and not in Gradescope.`}</strong></p>
    <p>{`Your Gradescope login is your Make School email, and your password can be changed at
`}<a parentName="p" {...{
        "href": "https://gradescope.com/reset_password"
      }}>{`https://gradescope.com/reset_password`}</a>{`. The same link can be
used if you need to set your password for the first time.`}</p>
    <h2>{`GitHub Account`}</h2>
    <p><a parentName="p" {...{
        "href": "https://github.com/Product-College-Courses/"
      }}>{`GitHub`}</a>{` is our Learning Management System for the
technical courses at Make School. Be sure to register for an account prior to your first day of
classes. Make School also uses GitHub to announce important information relating to the school. It
is your responsibility to check GitHub for these updates.`}</p>
    <h2>{`Slack Account`}</h2>
    <p><a parentName="p" {...{
        "href": "http://slack.com"
      }}>{`Slack`}</a>{` is the main platform Make School uses for informal communication.
Announcements, reminders about action items, and community conversations are shared via this
service. It is important that you are attentive to your Slack channels and messages, as this is
often the fastest way to share information with colleagues and Make School staff. Students are
automatically invited to Slack upon enrollment. To access the student Slack workspace on your
computer or mobile device, open the email invitation sent to your Make School email account and
click “join.” Slack will then guide you through the process of setting up your account.`}</p>
    <h2>{`Dominican University Technology Access`}</h2>
    <p>{`To access Dominican University services (like your @dominican.edu email), refer to the
`}<a parentName="p" {...{
        "href": "make.sc/du-tech-support"
      }}>{`Technology at Dominican`}</a>{` page.`}</p>
    <h2>{`Social Media Accounts`}</h2>
    <p>{`Make School has a robust `}<a parentName="p" {...{
        "href": "https://www.facebook.com/makeschool/"
      }}>{`Facebook`}</a>{`,
`}<a parentName="p" {...{
        "href": "https://www.instagram.com/make_school/?hl=en"
      }}>{`Instagram`}</a>{`, and
`}<a parentName="p" {...{
        "href": "https://www.linkedin.com/school/makeschool/"
      }}>{`LinkedIn`}</a>{` network! `}<strong parentName="p">{`Facebook`}</strong>{` is used to enhance
internal communications among the Make School community. You can join the following Make School
groups on Facebook:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.facebook.com/groups/MakeSchoolCommunity/"
        }}>{`Make School Community`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.facebook.com/makeschool/"
        }}>{`Make School`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.facebook.com/groups/916655231787097/"
        }}>{`Make School Women`}</a></li>
    </ul>
    <p><strong parentName="p">{`LinkedIn`}</strong>{` is a tool to connect internally with staff and students, as well as externally with
hiring partners, industry contacts, and other Make School affiliates. It is highly encouraged for
you to add connections and utilize this platform. LinkedIn is the number one way recruits reach out
to you when looking to hire, and it’s important that your LinkedIn profile is up-to-date with your
current projects, experience and education, and a professional headshot. We provide support to
students to create an effective LinkedIn profile, and we encourage students to join the Make School
Connect Group on LinkedIn to increase their network and develop connections in industry.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      